<div class="flex flex-col">
  <div class="flex items-center justify-start gap-2">
    <mat-form-field class="w-full">
      <mat-label>{{ "medicalDocuments.labels." + (!isAiSearchChecked() ? "search" : "contextSearch") | translate }}</mat-label>
      <input
        matInput
        type="text"
        [formControl]="searchControl"
        [placeholder]="'context.labels.searchPlaceholder' | translate"
      />
      @if (searchControl.value) {
        <button
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon matIconSuffix>close</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (isUploadBtnVisible()) {
      <input
        #fileInput
        class="hidden"
        [type]="'file'"
        [multiple]="false"
        (change)="onFileSelected($event)"
      />
      <button
        class="mb-4 flex items-center justify-center rounded-full border-2 border-solid border-primary-500 bg-transparent p-1.5 text-primary-500 hover:bg-gray-4 disabled:border-gray-2 disabled:text-gray-2"
        [disabled]="isUploadBtnDisabled()"
        [matTooltip]="isUploadBtnDisabled() ? ('medicalDocuments.tooltips.uploadDisabled' | translate) : ''"
        (click)="openArrayBuffer()"
      >
        <mat-icon [fontIcon]="'add'"></mat-icon>
      </button>

      @if (showDetailsButton()) {
        <button
          class="mb-4 flex items-center justify-center rounded-full bg-transparent p-2 hover:bg-gray-4"
          (click)="openDetails()"
        >
          <mat-icon [fontIcon]="'keyboard_tab'"></mat-icon>
        </button>
      }
    }
  </div>

  @if (isContextSearchVisible()) {
    <mat-checkbox
      class="-mt-2"
      [formControl]="contextSearchFlagControl"
      [checked]="isAiSearchChecked()"
      (change)="onAiToggleChange($event)"
    >
      {{ "medicalDocuments.labels.useContextSearch" | translate }}
    </mat-checkbox>
  }
</div>
